<template>
  <article
    v-if="id && postData"
    class="block-single-post"
    :class="{ list: list }"
  >
    <WpLink
      :url="postData.link"
      :title="postData.title.rendered.decodeHtmlEntities()"
      class="post-block-link"
    >
      <wpImage
        v-if="postData.featured_image_src"
        :data="postData.featured_image_src"
        size="large"
        class="post-block-image"
        lazy
        background
        placeholder
      />
      <div v-else class="post-block-image"></div>
      <div class="content-block">
        <ModuleHeading :level="3">{{ postData.title.rendered.decodeHtmlEntities() }}</ModuleHeading>
        <Categories
          v-if="postData.acf._categories"
          :categories="postData.acf._categories"
          :link="false"
          :title="false"
        />
      </div>
    </WpLink>
  </article>
  <div v-else class="block-single-post dummy">
    <div class="post-block-image"></div>
    <div class="dummy-text">
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="dummy-tags ">
      <span></span>
      <span></span>
    </div>
  </div>
</template>

<script>
import WpImage from "@/components/elements/WpImage";
import Categories from "@/components/blocks/CategoriesBlock";
import WpLink from "@/components/elements/WpLink";

import { mapGetters } from "vuex";

export default {
  name: "block-single-article",
  props: ["id", "list"],
  components: {
    WpImage,
    Categories,
    WpLink
  },
  computed: {
    ...mapGetters(["getPageById"]),
    postData() {
      let post = null;
      if (this.id) {
        post = this.getPageById(this.id);
      }
      return post;
    }
  }
};
</script>

<style lang="scss">
@import "./../../assets/scss/mixins.scss";
@import "./../../assets/scss/vars.scss";
.block-single-post {
  max-width: 33.33%;
  width: 100%;
  position: relative;
  padding-left: 12px;
  padding-right: 12px;
  margin-bottom: 25px;
  @include mquery(767px) {
    max-width: 100%;
  }
  &.list {
    max-width: 100%;
    padding: 0;
    .content-block {
      padding: 20px;
    }
    .categories-block {
      // display: none;
      margin-top: 10px;
    }
    .module-header {
      margin-bottom: 10px;
    }
    .post-block-image {
      padding-bottom: 0;
      min-height: 127px;
      margin: 0;
      width: 190px;
    }
    .post-block-link {
      padding: 0;
      flex-direction: row;
    }
  }
  .content-block {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  .post-block-link {
    color: inherit;
    text-decoration: none;
    padding: 20px;
    padding-top: 0;
    transition: box-shadow 0.12s ease-in-out;
    height: 100%;
    background: $colorGray;
    display: flex;
    flex-direction: column;
    &:hover {
      box-shadow: 0 0 10px 0 rgba(74, 79, 85, 0.5);
    }
  }
  .post-block-image {
    margin: 0;
    padding-bottom: 60%;
    margin-left: -20px;
    margin-right: -20px;
    margin-bottom: 20px;
    @extend %preloadBgLight;
  }
  .module-header {
    margin-bottom: 50px;
    flex: 1 0 auto;
  }
  .categories-block {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 0;
    margin-top: 0;
    .category-list {
      font-size: 14px;
    }
  }
}
</style>
